export default "__VITE_ASSET__DCbWMltY__"